import NavBar from "../Navbar/Navbar";
import PropTypes from "prop-types";
import SideBar from "../Sidebar/SideBar";
import "./School-District.css";
import { visuallyHidden } from "@mui/utils";
import { Link, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  createAdminForSchool,
  createSchoolByDistrict,
  districtAdminAssignDeviceToSchool,
  districtAdminRemoveDeviceFromSchool,
  districtAdminRemoveSchoolAdmin,
  editTeacherDetails,
  getAllAdminsForASchool,
  getAllDevicesForDestrictAdmin,
  getSchoolByDistrict,
  getSchoolByDistrictAdmin,
  getSchoolById,
  getSchoolDetails,
  getTeacherDetails,
  InviteSchoolTeacher,
  EditSchoolById,
  DeleteSchoolById,
} from "./api";
import getCookie, { districtAdminState, setDistrictCookie } from "../../Atom";
import { useRecoilValue, useRecoilState } from "recoil";
import ManageTeacherDevice from "../ManageTeacherDevice/ManageTeacherDevice";
import CustomModal from "../Modal/CusModal";
import { CircularProgress } from "@material-ui/core";
import { Modal, Button } from "react-bootstrap";
import Popup from "../popup/Popup";
import Tooltip from "@mui/material/Tooltip";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";

import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import {
  Box,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TableContainer,
  TableBody,
  Paper,
} from "@mui/material";
// import { useRecoilState } from "recoil";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const headCells = [
  {
    id: "_id",
    numeric: false,
    disablePadding: true,
    label: "Id",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "address",
    numeric: false,
    disablePadding: true,
    label: "Address",
  },
  {
    id: "createdAt",
    numeric: true,
    disablePadding: true,
    label: "Created",
  },
  {
    id: "manage",
    numeric: true,
    disablePadding: true,
    label: "Manage",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
              {headCell.id !== "manage" ? (
            <TableSortLabel
              sx={{ display: "flex" }}
              className=" mb-2"
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="div" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function AllSchools() {
  const [myUser, setmyUser] = useState();
  const newSchoolModal = useRef();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const history = useHistory();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const deleteSchoolModal = useRef();
  const allDevicesModal = useRef();
  const schoolAdminsModal = useRef();
  // const { token, districtId, type } = useRecoilValue(districtAdminState)
  const [schools, setSchools] = useState([]);
  const [devices, setDevices] = useState({ assigned: [], spare: [] });
  const [clicked, setClicked] = useState(false);
  const [schoolShow, setSchoolShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [currentSchool, setCurrentSchool] = useState(null);
  const [deviceType, setDeviceType] = useState(1);

  const [currentSchoolAdmins, setCurrentSchoolAdmins] = useState([]);
  const [adminType, setAdminType] = useState(1);
  const [newAdminData, setNewAdminData] = useState({ email: "", message: "" });
  const [currPage, setCurrPage] = useState(0);
  const [paged, setPaged] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [noOfPages, setNoOfPages] = useState(0);
  const [pageLimit, setPageLimit] = useState(25);

  const [newSchoolData, setNewSchoolData] = useState({ name: "", address: "" });

  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");

  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setDistrictCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      window.location.assign(
        `${window.location.protocol}//${hostname}/school-district`
      );
    });
  };

  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    let urlPage = parseInt(params.get("page")) || 0;
    let urlLimit = parseInt(params.get("limit")) || pageLimit;
      history.replace({
        pathname: `/schools`,
        search:
          "?page=" +
          urlPage +
          "&limit=" +
          urlLimit +
          "&orderBy=" +
          property +
          "&order=" +
          orderTemp,
      });
    getAllSchools(urlPage, urlLimit, property, orderTemp);
    setPaged(urlPage);
    setPageLimit(urlLimit);
    setOrder(orderTemp);
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = schools.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["district_admin_v1"];
      setmyUser(user);
      let urlPage = parseInt(params.get("page")) || 0;
      let urlLimit = parseInt(params.get("limit")) || pageLimit;
      let urlOrderBy = params.get("orderBy") || "createdAt";
      let urlOrder = params.get("order") || "desc";

      if (parseInt(params.get("page"))) {
        history.replace({
          pathname: `/schools`,
          search:
            "?page=" +
            urlPage +
            "&limit=" +
            urlLimit +
            "&orderBy=" +
            urlOrderBy +
            "&order=" +
            urlOrder,
        });
        setPaged(urlPage);
        getAllSchools(urlPage, pageLimit, urlOrderBy, urlOrder, user);
      } else {
        setPaged(0);
        history.push({
          pathname: `/schools`,
          search: `?page=0&limit=${pageLimit}&orderBy=${orderBy}&order=${order}`,
        });
        getAllSchools(0, pageLimit, orderBy, order, user);
      }
    }
  }, [0]);

  const getAllSchools = async (
    pages,
    limits,
    orderBy,
    order,
    user = myUser
  ) => {
    ////console.logtype)
    let res = await getSchoolByDistrictAdmin(
      user?.token,
      pages,
      limits,
      orderBy,
      order
    );

    if (res.error) {
      // alert('Failed fetching Schools. Try Again')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setSchools(res.res.data.data.schools);
      let divisor = parseInt(res.res.data.data.totalcount / limits);
      let remainder = res.res.data.data.totalcount % limits == 0 ? 0 : 1;
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
      ////console.logres.res.data.data.schools);
    }
  };

  const getSchoolFeatures = async (id, type, name) => {
    setCurrentSchool(id);
    ////console.logdistrictId);
    setSchoolShow(true);
    if (type === "edit") {
      setEditMode(true);
    } else {
      setDeleteMode(true);
    }
    // let res= await
  };

  const createNewSchool = async (e) => {
    e.preventDefault();
    setClicked(true);
    let res;
    if (!editMode && !deleteMode) {
      res = await createSchoolByDistrict(myUser?.token, newSchoolData);
    } else if (editMode) {
      res = await EditSchoolById(
        currentSchool,
        {
          name: newSchoolData.name.trim(),
          address: newSchoolData.address.trim(),
        },
        myUser?.token
      );
    } else {
      res = await DeleteSchoolById(currentSchool, myUser?.token);
    }
    setClicked(false);

    if (res?.error) {
      // alert('Failed performing this operation. Try Again')
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      feedBackMsg(true, "success", res?.res?.data?.msg);
      history.push({
        pathname: `/schools`,
        search: `?page=0&limit=${pageLimit}&orderBy=${orderBy}&order=${order}`,
      });
      getAllSchools(paged, pageLimit,orderBy,order);
    }
    setSchoolShow(false);
    setEditMode(false);
    setDeleteMode(false);
    setCurrentSchool("");
    setNewSchoolData({ name: "", address: "" });
  };

  const getAllDevices = async (schoolId) => {
    let resAssigned = await getAllDevicesForDestrictAdmin(
      myUser?.token,
      "all",
      schoolId
    );
    let resSpared = await getAllDevicesForDestrictAdmin(
      myUser?.token,
      "spare",
      schoolId
    );
    ////console.log'Check type of school',type)
    if (resSpared.error) {
      // alert('Error fetching devices. Try Again')
      if (resAssigned.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", resSpared.data.msg);
      }
    } else {
      // for(let i=0;i<25;i++){
      //   resAssigned.res.data.data.devices=[resAssigned.res.data.data.devices,...resAssigned.res.data.data.devices]
      //   resSpared.res.data.data.devices=[resSpared.res.data.data.devices,...resSpared.res.data.data.devices]
      // }
      setDevices({
        assigned: resAssigned.res.data.data.devices,
        spare: resSpared.res.data.data.devices,
      });
    }
  };
  const prepareDeviceBox = (schoolId) => {
    ////console.logschoolId)
    setCurrentSchool(schoolId);
    getAllDevices(schoolId);
    allDevicesModal.current.open();
  };

  const prepareAdminBox = (schoolId) => {
    setCurrentSchool(schoolId);
    schoolAdminsModal.current.open();
    getCurrentSchoolAdmins(schoolId);
  };

  const getCurrentSchoolAdmins = async (schoolId) => {
    let res = await getAllAdminsForASchool(myUser?.token, schoolId);
    if (res.error) {
      // alert('Failed fetching School Admins. Try Again')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      ////console.logres.res)
      setCurrentSchoolAdmins(res.res.data.data.admins);
    }
  };

  const assignThisDeviceToSchool = async (deviceId, schoolId) => {
    let res = await districtAdminAssignDeviceToSchool(
      deviceId,
      schoolId,
      myUser?.token
    );
    if (res.error) {
      // alert('Failed to assign this device to School. Try Again ')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      ////console.logres.res)
      feedBackMsg(true, "success", res.res.data.msg);
      // setDevices({assigned:resAssigned.res.data.data.devices,spare:resSpared.res.data.data.devices})
      getAllDevices(schoolId);
    }
  };

  const unassignThisDeviceToSchool = async (deviceId, schoolId) => {
    let res = await districtAdminRemoveDeviceFromSchool(
      deviceId,
      schoolId,
      myUser.token
    );
    if (res.error) {
      // alert('Failed to unassign this device. Try Again')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      ////console.logres.res)
      // setDevices({assigned:resAssigned.res.data.data.devices,spare:resSpared.res.data.data.devices})
      feedBackMsg(true, "success", res.res.data.msg);
      getAllDevices(schoolId);
    }
  };

  const createNewAdmin = async (e) => {
    e.preventDefault();
    setClicked(true);
    ////console.logtoken);
    let res = await createAdminForSchool(
      myUser.token,
      newAdminData,
      currentSchool
    );
    setClicked(false);

    if (res.error) {
      alert("Failed to create admin. Try Again");
    } else {
      alert("Invitation Sent!");
      setAdminType(1);
    }
  };

  const removeAdmin = async (adminId, schoolId) => {
    let res = await districtAdminRemoveSchoolAdmin(
      myUser.token,
      adminId,
      schoolId
    );
    if (res.error) {
      alert("Failed to remove admin. Try Again");
    } else {
      getCurrentSchoolAdmins(schoolId);
    }
  };

  const handleCloseAddModal = () => {
    ////console.log'Popup Closed');
    setSchoolShow(false);
    setEditMode(false);
    setDeleteMode(false);
    setCurrentSchool("");
    setNewSchoolData({ name: "", address: "" });
  };

  const handleChangePage = (event, newPage) => {
    setPaged(event.selected);
    let urlOrderBy = params.get("orderBy") || "createdAt";
    let urlOrder = params.get("order") || "desc";
    getAllSchools(event.selected, pageLimit,urlOrderBy,urlOrder);
    history.replace({
      pathname: `/schools`,
      search: "?page=" + event.selected,
    });
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - schools.length) : 0;
  return (
    <div>
      <NavBar />
      {myUser?.type != "individual" ? (
        <>
          <div className="schoolFlex">
            <h2>Schools</h2>

            {/* className="d-flex justify-content-end" */}
            <div style={{ marginTop: "50px" }}>
              <button
                className="btn btn-add float-right"
                onClick={() => {
                  setSchoolShow(true);
                }}
              >
                <i className="fas fa-plus-circle"></i> {"  "}
                <span>New School</span>
              </button>
              {/* <button className="add-btn w-100" onClick={()=>setSchoolShow(true)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 8V16" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 12H16" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <i className="fas fa-plus-circle"></i> {"  "}
          <span className="ml-2">New School</span>
        </button> */}
            </div>
          </div>
        </>
      ) : (
        <>
          <h2>School</h2>
        </>
      )}
      <br />
      <div className="d-flex justify-content-end align-items-end">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={noOfPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handleChangePage}
          containerClassName="pagination"
          activeClassName="activePage active"
          forcePage={currPage}
        />
      </div>
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer sx={{ height: "80vh", overflow: "auto" }}>
            <Table
              aria-labelledby="tableTitle"
              // size={ 'small'}
              stickyHeader
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={onSetOrder}
                rowCount={schools.length}
              />
              <TableBody>
                {schools
                  .map((data, index) => {
                    const isItemSelected = isSelected(data.name);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        onClick={(event) => handleClick(event, data.name)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={data.name}
                        selected={isItemSelected}
                      >
                        <TableCell align="center">{data._id}</TableCell>
                        <TableCell align="center">
                          <Link
                            to={`schools/${data._id}`}
                            style={{ color: "#E87D0B" }}
                          >
                            {data.name}
                          </Link>
                        </TableCell>
                        <TableCell align="center">{data?.address}</TableCell>
                        <TableCell align="center">
                          {new Date(data.createdAt).toLocaleDateString()}
                        </TableCell>
                        <TableCell align="center">
                          {" "}
                          <Tooltip title="Device" placement="top">
                            <Link onClick={() => prepareDeviceBox(data._id)}>
                              <svg
                                width="25"
                                height="25"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z"
                                  fill="#495057"
                                  stroke="#495057"
                                  strokeWidth="0.6"
                                />
                                <path
                                  d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z"
                                  fill="#495057"
                                  stroke="#495057"
                                  strokeWidth="0.6"
                                />
                                <path
                                  d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z"
                                  fill="#495057"
                                  stroke="#495057"
                                  strokeWidth="0.6"
                                />
                                <path
                                  d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z"
                                  fill="#495057"
                                  stroke="#495057"
                                  strokeWidth="0.6"
                                />
                                <path
                                  d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z"
                                  fill="#495057"
                                  stroke="#495057"
                                  strokeWidth="0.6"
                                />
                              </svg>
                            </Link>
                          </Tooltip>
                          &nbsp;
                          <Tooltip title="Edit" placement="top">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                getSchoolFeatures(data._id, "edit", data.name);
                                setNewSchoolData({
                                  name: data.name,
                                  address: data.address,
                                });
                              }}
                            >
                              <i className="fas fa-edit icon-size-30"></i>
                            </span>
                          </Tooltip>
                          &nbsp;
                          {myUser?.type != "individual" ? (
                            <Tooltip title="Delete" placement="top">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  getSchoolFeatures(
                                    data._id,
                                    "delete",
                                    data.name
                                  );
                                  setNewSchoolData({
                                    name: data.name,
                                    address: data.address,
                                  });
                                }}
                              >
                                <i className="fas fa-trash-alt icon-size-30"></i>
                              </span>
                            </Tooltip>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <CustomModal show={schoolShow}>
        <section id="hero-Msd">
          <div className="row main-div-modal">
            <div className="col-md-6 m-auto center-div text-center">
              <div className="p-2 center-div">
                <h2>
                  <button
                    onClick={handleCloseAddModal}
                    className="btn close-btn  rounded-circle float-right"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="20" cy="20" r="20" fill="#011627" />
                      <path
                        d="M27.0693 13.1005L12.9272 27.2426"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.0693 27.2426L12.9272 13.1005"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </h2>
                {!editMode && !deleteMode ? (
                  <>
                    <form onSubmit={(e) => createNewSchool(e)}>
                      <h2 className="custom-form-heading">Add New School</h2>
                      <label>
                        <h6>School</h6>
                      </label>
                      <input
                        type="text"
                        className="custom-form-input"
                        required
                        value={newSchoolData.name}
                        placeholder="School Name"
                        onChange={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            name: e.target.value,
                          })
                        }
                        onBlur={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            name: e.target.value.trim(),
                          })
                        }
                      />

                      <label>
                        <h6>School Address</h6>
                      </label>
                      <input
                        type="text"
                        className="custom-form-input"
                        required
                        placeholder="School Address"
                        value={newSchoolData.address}
                        onChange={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            address: e.target.value,
                          })
                        }
                        onBlur={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            address: e.target.value.trim(),
                          })
                        }
                      />

                      {!clicked && (
                        <input
                          type="submit"
                          className="custom-form-button"
                          value="Add"
                        />
                      )}
                      {clicked && (
                        <button className="custom-form-button" disabled>
                          Adding...
                        </button>
                      )}
                    </form>
                  </>
                ) : editMode ? (
                  <>
                    <form onSubmit={(e) => createNewSchool(e)}>
                      <h3 className="custom-form-heading">Edit School</h3>
                      <label>
                        <h6>School</h6>
                      </label>
                      <input
                        type="text"
                        className="custom-form-input"
                        value={newSchoolData.name}
                        required
                        placeholder="School Name"
                        onChange={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            name: e.target.value,
                          })
                        }
                        onBlur={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            name: e.target.value.trim(),
                          })
                        }
                      />

                      <label>
                        <h6>School Address</h6>
                      </label>
                      <input
                        type="text"
                        className="custom-form-input"
                        value={newSchoolData.address}
                        required
                        placeholder="School Address"
                        onChange={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            address: e.target.value,
                          })
                        }
                        onBlur={(e) =>
                          setNewSchoolData({
                            ...newSchoolData,
                            address: e.target.value.trim(),
                          })
                        }
                      />

                      {!clicked && (
                        <input
                          type="submit"
                          className="custom-form-button"
                          value="Edit"
                        />
                      )}
                      {clicked && (
                        <button className="custom-form-button" disabled>
                          Adding...
                        </button>
                      )}
                    </form>
                  </>
                ) : (
                  <>
                    <div className="mt-3">
                      <h6>Delete School</h6>
                    </div>
                    <div className="col-md-9 text-left  col-9 m-auto">
                      <div className="form-group mt-4   p-20">
                        <h5>Are you Sure to Delete this School?</h5>
                        <br></br>
                        <input
                          type="text"
                          readOnly
                          value={newSchoolData.name}
                          className="form-control"
                          placeholder="School Name"
                        />
                      </div>
                      <br />
                      <br />
                      <div className="form-group">
                        {clicked ? (
                          <CircularProgress />
                        ) : (
                          <button
                            type="submit"
                            className="cta-btn-red"
                            onClick={(e) => createNewSchool(e)}
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </CustomModal>

      <Popup ref={allDevicesModal}>
        <div>
          <br />
          <div className="d-flex justify-content-center">
            <button
              className="tab-btn"
              style={{
                backgroundColor: deviceType === 1 ? "#4196EB" : "#fff",
                color: deviceType === 1 ? "#fff" : "#000",
              }}
              onClick={() => setDeviceType(1)}
            >
              Allocated Devices
            </button>
            <button
              className="tab-btn"
              style={{
                backgroundColor: deviceType === 2 ? "#4196EB" : "#fff",
                color: deviceType === 2 ? "#fff" : "#000",
              }}
              onClick={() => setDeviceType(2)}
            >
              Available Devices
            </button>
          </div>
          <div style={{ maxHeight: "275px", overflowY: "auto" }}>
            {deviceType === 2 &&
              devices.spare.map((item) => {
                return (
                  <div className="devices-table" key={item._id}>
                    <td style={{ fontWeight: "600" }}>{item.name}</td>
                    <td>
                      <button
                        className="assign-btn"
                        onClick={() =>
                          assignThisDeviceToSchool(item._id, currentSchool)
                        }
                      >
                        Assign
                      </button>
                    </td>
                  </div>
                );
              })}
            {deviceType === 1 &&
              devices.assigned.map((item) => {
                if (item.school === currentSchool) {
                  return (
                    <div className="devices-table" key={item._id}>
                      <td style={{ fontWeight: "600" }}>{item.name}</td>
                      <td>
                        {myUser.type != "individual" ? (
                          <button
                            className="unassign-btn"
                            onClick={() =>
                              unassignThisDeviceToSchool(
                                item._id,
                                currentSchool
                              )
                            }
                          >
                            Remove
                          </button>
                        ) : null}
                      </td>
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </Popup>

      <Popup ref={schoolAdminsModal}>
        {adminType === 1 && (
          <div style={{ minHeight: "275px" }}>
            <button className="add-btn-second" onClick={() => setAdminType(2)}>
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="white"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 8V16"
                  stroke="white"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 12H16"
                  stroke="white"
                  strokeWidth="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span className="ml-2">New Admin</span>
            </button>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentSchoolAdmins.map((item) => {
                  return (
                    <tr key={item._id}>
                      <td>
                        {item.fName} {item.lName}
                      </td>
                      <td>{item.email}</td>
                      <td>
                        <button
                          className="unassign-btn"
                          onClick={() => {
                            removeAdmin(item._id, currentSchool);
                          }}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {adminType === 2 && (
          <div>
            <button className="add-btn-second" onClick={() => setAdminType(1)}>
              Back
            </button>
            <form onSubmit={(e) => createNewAdmin(e)}>
              <h3 className="custom-form-heading">Add New Admin</h3>
              <input
                type="email"
                className="custom-form-input"
                required
                placeholder="Admin's Email"
                onChange={(e) =>
                  setNewAdminData({ ...newAdminData, email: e.target.value })
                }
                onBlur={(e) =>
                  setNewAdminData({
                    ...newAdminData,
                    email: e.target.value.trim(),
                  })
                }
              />

              <input
                type="textarea"
                className="custom-form-input"
                placeholder="Any Message"
                onChange={(e) =>
                  setNewAdminData({ ...newAdminData, message: e.target.value })
                }
                onBlur={(e) =>
                  setNewAdminData({
                    ...newAdminData,
                    message: e.target.value.trim(),
                  })
                }
              />

              {!clicked && (
                <input
                  type="submit"
                  className="custom-form-button"
                  value="Send Invitation"
                />
              )}
              {clicked && (
                <button className="custom-form-button" disabled>
                  Sending...
                </button>
              )}
            </form>
          </div>
        )}
      </Popup>

      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}
